import { isResourceDetailImage, isResourceDetailDocument } from './resourceDetailGuards.js';

const getResourceDownloadText = (resource) => {
  if (isResourceDetailImage(resource)) {
    return "Download image";
  }
  if (isResourceDetailDocument(resource) && resource.mimeType?.startsWith("application/pdf")) {
    return "Download PDF";
  }
  return "Download";
};

export { getResourceDownloadText };
//# sourceMappingURL=getResourceDownloadText.js.map
